import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-right-down-icon',
  templateUrl: './design-anchor-right-down.component.html'
})
export class DesignAnchorRightDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
